import { Calendar } from "primereact/calendar"
import "./primeCalendarSetup"

export default function PPColumnDateFilter({ value, onChange, placeholder, locale, dateFormat }) {
    return (
        <Calendar
            value={value}
            onChange={(e) => onChange(e.value)}
            dateFormat={dateFormat}
            locale={locale}
            showIcon
            showButtonBar
            showTime={false}
            placeholder={placeholder}
            className="pp-column-date-filter p-column-filter w-100"
            panelClassName="pp-column-date-filter-panel"
            inputClassName="pp-column-date-filter-input"
        />
    )
}
